// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.attendancewidget-inline-1 {
  display: flex;
  gap: 6px;
}

.attendancewidget-inline-2 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-top: 12px;
}

.attendancewidget-inline-3 {
  margin-top: 16px;
}

.attendancewidget-inline-4 {
  display: flex;
  justify-content: space-between;
  margin-bottom: 6px;
}

.attendancewidget-inline-5 {
  font-size: 12px;
  font-weight: 600;
  color: var(--text-secondary);
}

.attendancewidget-inline-6 {
  font-size: 12px;
  font-weight: 700;
  color: var(--success);
}

.attendancewidget-inline-7 {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 12px;
}

.attendancewidget-inline-8 {
  font-weight: 700;
  font-size: 14px;
}

.attendancewidget-inline-9 {
  width: 140px;
}

.attendancewidget-inline-10 {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-bottom: 10px;
  font-size: 10px;
}

.attendancewidget-inline-11 {
  display: flex;
  align-items: center;
  gap: 4px;
}

.attendancewidget-inline-12 {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.attendancewidget-inline-13 {
  padding: 4px;
  text-align: center;
}

.attendancewidget-inline-14 {
  padding: 2px;
}

.attendancewidget-inline-15 {
  overflow-x: auto;
}

.attendancewidget-inline-16 {
  font-weight: 600;
  font-size: 12px;
}

.attendancewidget-inline-17 {
  overflow-x: auto;
}

.attendancewidget-inline-18 {
  font-weight: 600;
  font-size: 12px;
}

.attendancewidget-dyn-1 {
  background: var(--attendancewidget-1-background);
}

.attendancewidget-dyn-2 {
  background: var(--attendancewidget-2-background);
}

.attendancewidget-dyn-3 {
  color: var(--attendancewidget-3-color);
}

.attendancewidget-dyn-4 {
  color: var(--attendancewidget-4-color);
}

.attendancewidget-dyn-5 {
  height: 8px;
  background: var(--attendancewidget-5-background);
  border-radius: 8px;
  overflow: hidden;
}

.attendancewidget-dyn-6 {
  height: 100%;
  width: var(--attendancewidget-6-width);
  background: linear-gradient(90deg,#2563eb,#60a5fa);
  border-radius: 8px;
  transition: width 1s ease;
}

.attendancewidget-dyn-7 {
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: var(--attendancewidget-7-background);
}

.attendancewidget-dyn-8 {
  width: 28px;
  height: 28px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: var(--attendancewidget-8-background);
  color: var(--attendancewidget-8-color);
  font-weight: 500;
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/Intern/AttendanceWidget.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;EACf,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,WAAW;EACX,gDAAgD;EAChD,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,sCAAsC;EACtC,kDAAkD;EAClD,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gDAAgD;EAChD,sCAAsC;EACtC,gBAAgB;AAClB","sourcesContent":[".attendancewidget-inline-1 {\n  display: flex;\n  gap: 6px;\n}\n\n.attendancewidget-inline-2 {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.attendancewidget-inline-3 {\n  margin-top: 16px;\n}\n\n.attendancewidget-inline-4 {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 6px;\n}\n\n.attendancewidget-inline-5 {\n  font-size: 12px;\n  font-weight: 600;\n  color: var(--text-secondary);\n}\n\n.attendancewidget-inline-6 {\n  font-size: 12px;\n  font-weight: 700;\n  color: var(--success);\n}\n\n.attendancewidget-inline-7 {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-bottom: 12px;\n}\n\n.attendancewidget-inline-8 {\n  font-weight: 700;\n  font-size: 14px;\n}\n\n.attendancewidget-inline-9 {\n  width: 140px;\n}\n\n.attendancewidget-inline-10 {\n  display: flex;\n  gap: 10px;\n  flex-wrap: wrap;\n  margin-bottom: 10px;\n  font-size: 10px;\n}\n\n.attendancewidget-inline-11 {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n}\n\n.attendancewidget-inline-12 {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 12px;\n}\n\n.attendancewidget-inline-13 {\n  padding: 4px;\n  text-align: center;\n}\n\n.attendancewidget-inline-14 {\n  padding: 2px;\n}\n\n.attendancewidget-inline-15 {\n  overflow-x: auto;\n}\n\n.attendancewidget-inline-16 {\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.attendancewidget-inline-17 {\n  overflow-x: auto;\n}\n\n.attendancewidget-inline-18 {\n  font-weight: 600;\n  font-size: 12px;\n}\n\n.attendancewidget-dyn-1 {\n  background: var(--attendancewidget-1-background);\n}\n\n.attendancewidget-dyn-2 {\n  background: var(--attendancewidget-2-background);\n}\n\n.attendancewidget-dyn-3 {\n  color: var(--attendancewidget-3-color);\n}\n\n.attendancewidget-dyn-4 {\n  color: var(--attendancewidget-4-color);\n}\n\n.attendancewidget-dyn-5 {\n  height: 8px;\n  background: var(--attendancewidget-5-background);\n  border-radius: 8px;\n  overflow: hidden;\n}\n\n.attendancewidget-dyn-6 {\n  height: 100%;\n  width: var(--attendancewidget-6-width);\n  background: linear-gradient(90deg,#2563eb,#60a5fa);\n  border-radius: 8px;\n  transition: width 1s ease;\n}\n\n.attendancewidget-dyn-7 {\n  width: 8px;\n  height: 8px;\n  border-radius: 4px;\n  background: var(--attendancewidget-7-background);\n}\n\n.attendancewidget-dyn-8 {\n  width: 28px;\n  height: 28px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 6px;\n  background: var(--attendancewidget-8-background);\n  color: var(--attendancewidget-8-color);\n  font-weight: 500;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
